import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import MinInventoryByProducts from './components/MinInventoryByProducts';

const minInventoryByProducts = (props,{ t }) => (
  <Container>
    <MinInventoryByProducts {...props} />
  </Container>
);

minInventoryByProducts.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(minInventoryByProducts);
